

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";




//import brandVideo from '../../assets/video/brand.mp4'

import openAudioImg from '../../assets/openAudio.png'
import closeAudioImg from '../../assets/closeAudio.png'

import logoImg from '../../assets/logo.png'
import bannerLogoImg from '../../assets/home/bannerlogo.png'



import { currentColorStyle, useGlobalFunc } from "../../global/constants.js";
import ReactPlayer from 'react-player'
import { useSelector } from "react-redux";
import Div100vh from "react-div-100vh";


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);

    const menuData = useSelector(state => state.menu);



    const { setLoading, successToast, errorToast } = useGlobalFunc()

    const scrollContainerRef = useRef(null);
    const videoDivRef = useRef(null);

    const [windowHeight, setWindowHeight] = useState(window.innerHeight)
    const [scrollPosition, setScrollPosition] = useState(0)

    const [audio, setAudio] = useState(false)
    const [isPlaying, setIsPlaying] = useState(true)




    const handleScroll = () => {
        //console.log(windowHeight)
        const newScrollPosition = scrollContainerRef.current.scrollTop;
        const scrollHeight = scrollContainerRef.current.scrollHeight;
        // 容器的高度
        const containerHeight = scrollContainerRef.current.clientHeight;

        let threshold = 670

        // if (newScrollPosition < threshold) {
        //     scrollContainerRef.current.scrollTop = threshold;
        // }

        // // 禁止滚动到底部
        // if (scrollHeight - newScrollPosition - containerHeight < threshold) {
        //     scrollContainerRef.current.scrollTop = scrollHeight - containerHeight - threshold;
        // }

        console.log(containerHeight)


        setScrollPosition(scrollContainerRef.current.scrollTop);
        console.log(scrollPosition)


        if (scrollContainerRef.current.scrollTop > containerHeight * 1.95) {
            setIsPlaying(false)
            if (audio) {
                setAudio(false)
            }
        }
        else {
            setIsPlaying(true)
        }

    };


    function countOpacity(page) {
        if (page == -100) {
            return 0
        }
        if (!scrollContainerRef.current) {
            return 0
        }

        let windowHeight = scrollContainerRef.current.clientHeight
        if (scrollPosition > (windowHeight * (page) - (windowHeight * 0.1)) && scrollPosition < (windowHeight * (page) + (windowHeight * 0.1))) {
            return 1
        }
        else {
            return 0
        }

    }


    function handleResize() {
        setWindowHeight(window.innerHeight)
    }


    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return <div className="relative bg-black " >

        <Div100vh className=" homeWrapper  hiddenScrollBar "
            ref={scrollContainerRef}
            onScroll={handleScroll}>
            {
                videoDivRef &&
                <div className="z-10 bg-black pointer-events-none absolute left-0 top-0  flex w-full h-full flex-col  " style={{ transform: `translateY( ${-(scrollPosition - scrollContainerRef.current?.clientHeight)}px)` }}>
                    <ReactPlayer
                        // config={{
                        //     file: {
                        //         attributes: {
                        //             crossOrigin: "true",
                        //         }
                        //     }
                        // }}
                         disablePictureInPicture={true}
                        loop={true}
                        playing={isPlaying}
                        muted={!audio}
                        playsinline
                        onReady={(e) => {
                            const player = e.getInternalPlayer();
                            player.setAttribute('muted', 'true');
                        }}
                        width="100%" height="100%" url={"https://s3.alphamars.co/vedio/product.mp4"}
                        className="pointer-events-none"
                    />
                </div>
            }

            <div onClick={() => setAudio(!audio)} className={`${countOpacity(1) == 0 && "pointer-events-none"} z-20 bg-red1 cursor-pointer anim hover:bg-opacity-100  bg-opacity-40 w-8 lg:w-10 h-8 lg:h-10 absolute right-7 lg:right-[34px] top-16  p-2 sm:p-[10px]  rounded-full `} style={{ opacity: countOpacity(1) }}>
                {
                    !audio ?
                        <img className="w-full h-full object-contain " src={closeAudioImg} />
                        :
                        <img className="w-full h-full object-contain " src={openAudioImg} />
                }
            </div>

            <div className={` max-w-[880px] z-10 mx-auto  flex  items-center sticky w-full sm:w-1/2 h-full top-0 left-0 bg-transparent `}>
                {/* <div className=" px-6 absolute left-0 top-1/2 -translate-y-1/2 flex w-full flex-col justify-center items-center anim" style={{ opacity: countOpacity(1) }}>
                    <img className=" w-full object-contain" src={bannerLogoImg} />
                </div> */}



                {
                    menuData && menuData.slice(0, 4).map((i, index) =>
                        <div key={index} className={`${countOpacity(index + 2) == 0 && "pointer-events-none"} px-6 absolute left-0 top-1/2 -translate-y-1/2 flex w-full flex-col justify-center items-center anim`} style={{ opacity: countOpacity(index + 2) }}>
                            <img className="w-12 object-contain mb-2 " src={logoImg} />
                            <p className=" italic text-2xl font-bold tracking-widest">{i.engName}</p>
                            <p className="mb-8  text-sm font-bold  ">{i.name}</p>
                            <p className="mb-14 text-xs tracking-widest">{i.description}</p>
                            <button onClick={() => navigate(`/producttype?categoryId=${i.id}`)} className={`bg-white rounded-full text-xs w-36 py-2 font-bold `} style={currentColorStyle(i.color)}>MORE</button>
                        </div>

                    )
                }
            </div>


            <div className="pointer-events-none ">
                <Div100vh ref={videoDivRef} className="homeContent  ">
                    {/* <div className=" !pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-black  overflow-hidden  flex w-full h-full flex-col  anim">

                         <ReactPlayer
                            config={{
                                file: {
                                    attributes: {
                                        crossOrigin: "true",
                                    }
                                }
                            }}
                            disablePictureInPicture={true}
                            loop={true}
                            playing={isPlaying}
                            muted={!audio}
                            playsinline
                            onReady={(e) => {
                                const player = e.getInternalPlayer();
                                player.setAttribute('muted', 'true');
                            }}
                            width="100%" height="100%" url={brandVideo}
                            className="pointer-events-none"
                            style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
                        /> 


                    </div> */}

                </Div100vh>
                {/* <Div100vh className="homeContent bg-black ">
                    
                </Div100vh > */}
                {
                    menuData && menuData.slice(0, 4).map(i =>
                        <Div100vh className=" homeContent " >
                            <img className="w-full h-full object-cover homemask" src={i.image} />
                        </Div100vh >
                    )

                }

            </div>


        </Div100vh>




    </div >
}

export default Home